import { h } from 'preact';
export const AlertTriangle = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
        h("line", { x1: "12", y1: "9", x2: "12", y2: "13" }),
        h("line", { x1: "12", y1: "17", x2: "12.01", y2: "17" })));
};
//# sourceMappingURL=alert-triangle.js.map